export const flatProjectTypeKeys = ['project_type_jp_for_consulting'];
